import React from 'react'
import styled from 'styled-components'

// Shared step-dot progress indicator: a row of dots where past + active steps fill
// with the primary colour and the active dot grows with a ringed centre. Extracted
// from SecondaryNavigation so the AI-wizard shell and the form nav share one source.
interface IProps {
  count: number
  // Index of the active step; -1 leaves every dot in its "todo" state.
  activeIndex: number
  className?: string
}

const StepDots: React.FC<IProps> = ({ count, activeIndex, className }) => (
  <Steps className={className}>
    {Array.from({ length: count }).map((_, index) => (
      <Step
        key={`step-dot-${index}`}
        past={index < activeIndex}
        active={index === activeIndex}
      />
    ))}
  </Steps>
)

export default StepDots

const Steps = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Step = styled.div<{ past?: boolean; active?: boolean }>`
  position: relative;
  width: ${({ active }) => (active ? 16 : 8)}px;
  height: ${({ active }) => (active ? 16 : 8)}px;
  border-radius: 50%;
  background-color: ${({ theme, active, past }) =>
    active || past ? theme.colors.primary : theme.colors.textLighter};

  ${({ active, theme }) =>
    active &&
    `
    &:before {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      border: 2px solid ${theme.colors.primaryLight};
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      background-color: ${theme.colors.primary};
    }
  `}

  &:not(:last-of-type) {
    margin-right: 14px;

    &:after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 100%;
      width: 14px;
      height: 2px;
      background-color: ${({ theme, past }) =>
        past ? theme.colors.primary : theme.colors.textLighter};
    }
  }
`
